// prettier-ignore
export default [
    "//workflow-release-data.s3.eu-central-1.amazonaws.com/",
    "//files.rotostampa.com/workflow-release-data/",
    "//workflow-dev-data.s3.eu-central-1.amazonaws.com/",
    "//workflow-local-data.s3.eu-central-1.amazonaws.com/"
]